import ApplicationController from '../../../application_controller'
import Highcharts from 'highcharts'
import Exporting from 'highcharts/modules/exporting'
import Map from 'highcharts/modules/map'
Exporting(Highcharts)
Map(Highcharts)

export default class extends ApplicationController {
  doConnect() {
    this.initializeHighcharts()
    this.renderChart()
  }

  initializeHighcharts() {
    Highcharts.setOptions({
      chart: {
        animation: false,
        borderColor: '#D8D8D8',
        borderWidth: 0,
        style: {
          fontFamily: 'Uni Neue'
        }
      },
      plotOptions: {
        series: {
          animation: false,
          pointPadding: 0,
          dataLabels: {
            style: {
              fontWeight: '400'
            }
          },
          states: {
            hover: {
              enabled: false
            }
          }
        }
      },
      legend: {
        itemStyle: {
          'font-weight': '400',
          color: '#434343'
        },
        symbolRadius: 2,
        verticalAlign: 'top',
        align: 'left'
      },

      title: {
        text: ''
      },

      yAxis: {
        labels: {
          style: {
            color: '#434343'
          }
        },
        title: {
          text: null
        },
        allowDecimals: false,
        gridLineColor: '#CDCDCD'
      },

      xAxis: {
        labels: {
          style: {
            color: '#434343'
          }
        },
        allowDecimals: false
      },

      navigation: {
        buttonOptions: {
          enabled: false
        }
      }
    })
  }

  seriesWithParams(series, serieParams) {
    return series.map((serie) => {
      return Object.assign(serie, serieParams)
    })
  }

  isChartDisplayable() {
    console.error('[stimulus-charts-base] You need to define the isChartDisplayable method on your controller.')
  }

  get chartOptions() {
    console.error('[stimulus-charts-base] You need to define the chartOptions get method on your controller.')
  }

  renderChart() {
    if (this.isChartDisplayable()) {
      Highcharts.chart(this.element, this.chartOptions)
    } else {
      console.warn(`[${this.identifier}] - Something went wrong. Chart was not displayable`)
    }
  }
}
